import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useCodeEditor } from '../CodeEditor/context';

const propTypes = {
  onToggle: PropTypes.func,
}

function PageHelpers({ onToggle }) {
  const { editorRef } = useCodeEditor()

  const handleClickLink = useCallback((value) => {
    editorRef.current.setValue(editorRef.current.getValue() + value)
    onToggle()
  }, [editorRef, onToggle])

  return <div>
    <h3>Page Helpers</h3>
    <p className='mb-0'>
      Mergetag helpers make it possible to transform content as needed. The helper must be called between braces
      and the value to be processed must be added between parentheses. It is possible to nest helper calls:
    </p>
    <ul style={{ listStyleType: 'none' }}>
      <li className="font-italic">{'ex: {md5(first-name="{firstName}"&last-name="{lastName}")}'}</li>
      <li className="font-italic">{'ex: {md5(lower(email={email})}'}</li>
    </ul>
    <ul>
      {HELPERS.map((helper, index) => {
        return <li key={index}>
          <span className="btn-link text-secondary" style={{ cursor: 'pointer' }} onClick={() => handleClickLink(`{${helper}()}`)} ><b>{`{${helper}()}`}</b></span>
        </li>
      })}
    </ul>
  </div>
}

PageHelpers.propTypes = propTypes
PageHelpers.defaultProps = {}

export default PageHelpers

const HELPERS = ['md5', 'lower', 'upper', 'capitalize', 'url_param_value']
